import React, { useContext, useRef } from "react";
import Button from "../Components/Button";
import ReportsLayout from "./ReportsLayout";
import useSalesSummary from "../hooks/useSalesSummary";
import { FilterContext } from "../FilterContextProvider";
import ReactToPrint from "react-to-print";
import Select from "react-select";
import useDateSelections from "../hooks/useDateSelections";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowLeft, faSpinner} from "@fortawesome/free-solid-svg-icons";
import { exportToCSV } from "../Utility/Csv";

const COGS = () => {
  const { filterData } = useContext(FilterContext);
  const { productsToRender, totalCOGS, resultsLoading } = useSalesSummary("");
  const printRef = useRef();
  const { dateOptions, handleDateSelect, renderCustomDateSelector } =
    useDateSelections();

  const prodsToExport = productsToRender
    .filter((prod) => prod.sold !== 0)
    .map((prod) => ({
      Name: prod.name,
      Size: prod.product_size,
      Sold: prod.sold,
      Average_cost: prod.gross_cost / prod.sold,
      Gross_cost: prod.gross_cost,
    }));

  const totals = {
    Name: "Total",
    Size: "",
    Sold: productsToRender.reduce((a, b) => {
      return a + b.sold;
    }, 0),
    Average_cost: "",
    Gross_cost: totalCOGS,
  };

  const combined = prodsToExport.concat(totals);

  return (
    <ReportsLayout>
      <div className="mt-8 mx-8 py-10 px-12 bg-white rounded-lg border">
        {productsToRender.length > 0 && (
          <div className="flex justify-end text-sm">
            <ReactToPrint
              trigger={() => <Button className="button" text="Print"></Button>}
              content={() => printRef.current}
            />
            <div className="ml-2">
              <Button
                className="button button-white"
                text="Export"
                onClick={() =>
                  exportToCSV(combined, `${filterData.artist_name}_cogs`)
                }
              ></Button>
            </div>
          </div>
        )}
        <div className="max-w-max">
          <Link to="/reports">
            <div className="-mt-6 mb-6 font-medium text-black text-sm">
              <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to
              reports
            </div>
          </Link>
        </div>
        <div className="flex flex-col text-sm w-1/4">
          <span className="text-xs">SELECT DATE RANGE</span>
          <Select
            id="date"
            className="text-xs font-light w-full"
            placeholder="Select date range"
            options={dateOptions}
            onChange={handleDateSelect}
            value={dateOptions?.filter(
              (each) => each.value === filterData.date_button
            )}
          />
        </div>
        <div className="my-4 w-1/2">
          {filterData.date_button === "custom" && renderCustomDateSelector()}
        </div>
        <div ref={printRef} className="mt-8 mx-8 text-black">
          <div className="flex text-lg font-bold mb-2">
            <div>
              <div className="text-xl font-extrabold">TM COGS Report</div>
              <div>{filterData.artist_name}</div>
            </div>
            <div className="ml-32 text-base font-normal italic">
              <div>Start Date:</div>
              <div>End Date:</div>
              <div>Total COGS:</div>
            </div>
            <div className="ml-2 text-base font-normal italic">
              <div>
                {filterData.start_date?.slice(5, 7)}/
                {filterData.start_date?.slice(8, 10)}/
                {filterData.start_date?.slice(0, 4)}
              </div>
              <div>
                {filterData.end_date?.slice(5, 7)}/
                {filterData.end_date?.slice(8, 10)}/
                {filterData.end_date?.slice(0, 4)}
              </div>
              <div>
                {totalCOGS?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </div>
            </div>
          </div>
          <table className="w-full">
            <thead className="text-xs font-light">
              <tr className="text-right h-12">
                <td className="w-2/5 text-left">PRODUCT</td>
                <td className="w-1/25 text-left">SIZE</td>
                <td className="w-1/6">SOLD</td>
                <td className="w-1/6">AVERAGE COST</td>
                <td className="w-1/6">GROSS COST</td>
              </tr>
            </thead>
            <tbody>
              {productsToRender
                .filter((prod) => prod.sold !== 0)
                .map((productToRender, i) => {
                  return (
                    <tr
                      key={productToRender.id}
                      className="text-sm text-right h-7"
                    >
                      <td id={`product_name_${i}`} className="text-left">
                        {productToRender.name}
                      </td>
                      <td id={`size_${i}`} className="text-left">
                        {productToRender.product_size}
                      </td>
                      <td id={`sold_${i}`}>{productToRender.sold}</td>
                      <td id={`average_cost_${i}`}>
                        $
                        {(
                          productToRender.gross_cost / productToRender.sold
                        )?.toFixed(2)}
                      </td>
                      <td id={`gross_cost_${i}`}>
                        ${productToRender.gross_cost?.toFixed(2)}
                      </td>
                    </tr>
                  );
                })}

            </tbody>

          </table>
          {resultsLoading && ( <div className="w-full flex justify-center h-full items-center"><FontAwesomeIcon icon={faSpinner}
                                                                                                                spin></FontAwesomeIcon>
          </div>)}
        </div>
      </div>
    </ReportsLayout>
  );
};

export default COGS;
